import { TextField } from "@mui/material";

import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

// 1. Créez votre fonction de filtrage personnalisée
// Le createFilterOptions est un utilitaire de MUI qui permet de construire
// la fonction de filtrage de manière simple.
const filterOptions = createFilterOptions({
  // 'matchFrom': 'any' permet de chercher n'importe où dans la chaîne (pas seulement au début)
  matchFrom: "any",
  // La liste des champs dans lesquels la recherche doit être effectuée
  limit: 100, // Optionnel: Limite le nombre de résultats affichés
  // Ici, vous passez les clés de l'objet option à prendre en compte.
  // getOptionLabel est déjà pris en compte par défaut, donc 'name' l'est.
  // Il suffit d'ajouter 'key_words'.
  stringify: (option) => option.name + " " + option.key_words,
});

const ActivitePdecForm = ({
  formData = [],
  errors,
  activitesPdec,
  handleChange,
  handleFieldFocus,
}) => {
  return (
    <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8">
      <Autocomplete
        id="activite-pdec"
        options={activitesPdec}
        size="small"
        fullWidth
        onChange={(event, value) =>
          handleChange("activite_pdec_id", value?.id || "")
        }
        onFocus={() => handleFieldFocus("activite_pdec")}
        value={
          activitesPdec.find((p) => p.id === formData.activite_pdec_id) || null
        }
        getOptionLabel={(option) => option.name}
        // 2. Appliquez la fonction de filtrage personnalisée
        filterOptions={filterOptions}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Rechercher Activité"
            error={!!errors.activite_pdec}
            helperText={errors.activite_pdec}
          />
        )}
      />
    </div>
  );
};

export default ActivitePdecForm;
